import { render, staticRenderFns } from "./examresultsdetail.vue?vue&type=template&id=5fd79210&scoped=true"
import script from "./examresultsdetail.vue?vue&type=script&lang=js"
export * from "./examresultsdetail.vue?vue&type=script&lang=js"
import style0 from "./examresultsdetail.vue?vue&type=style&index=0&id=5fd79210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd79210",
  null
  
)

export default component.exports